module.exports = function() {
  return new Worker(__webpack_public_path__ + "8d1f28ede356fa017cfc.worker.js");
};